export const SEAT_BUTTON_SHAPES = ["tent", "table", "picnic", "house"];

const SUPPORTED_SHAPES = new Set(SEAT_BUTTON_SHAPES);

export function getSeatButtonShape(meta) {
  const value = meta?.button_shape;
  return typeof value === "string" && SUPPORTED_SHAPES.has(value) ? value : null;
}

export function getSeatShapeTextStyle(shape) {
  if (shape === "tent") {
    return { transform: "translate(22%, 4%)", maxWidth: "54%" };
  }
  if (shape === "house") {
    return { transform: "translate(22%, 4%)", maxWidth: "64%" };
  }
  return {};
}

export function getSeatShapeStyle(shape) {
  if (shape === "tent") {
    return {
      borderRadius: 0,
      clipPath: "polygon(50% 2%, 98% 96%, 2% 96%)",
    };
  }
  if (shape === "picnic") {
    return {
      borderRadius: 0,
      clipPath: "polygon(12% 2%, 88% 2%, 100% 50%, 88% 98%, 12% 98%, 0% 50%)",
    };
  }
  if (shape === "house") {
    return {
      borderRadius: 0,
      clipPath: "polygon(50% 3%, 96% 35%, 96% 98%, 4% 98%, 4% 35%)",
    };
  }
  if (shape === "table") {
    return {
      borderRadius: 2,
    };
  }
  return {
    borderRadius: 18,
  };
}

export function getSeatShapeFrameStyle(shape, accent) {
  if (!shape) {
    return {};
  }
  return {
    background: accent,
    border: "none",
    padding: 0,
  };
}

export function getSeatShapeFillStyle(shape, statusStyle) {
  if (!shape) {
    return {};
  }
  return {
    background: statusStyle.background,
    inset: 2,
  };
}
